import React, { FunctionComponent } from 'react';
import cn from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import './StateIcon.scss';
import { UpdateState } from 'enums';

interface IStateIconProps {
    className?: string
    state: UpdateState,
}

const stateClasses = {
    [UpdateState.Draft]: 'draft',
    [UpdateState.AwaitApproval]: 'awaitApproval',
    [UpdateState.Scheduled]: 'scheduled',
    [UpdateState.Running]: 'running',
    [UpdateState.Canceled]: 'canceled',
    [UpdateState.Error]: 'error',
    [UpdateState.Done]: 'done',
}

export const StateIcon: FunctionComponent<IStateIconProps> = function StateIcon(props) {
    const { className, state } = props;

    const iconClass = cn('stateIcon', className, stateClasses[state]);

    const icons = {
        [UpdateState.Draft]: (
            <FontAwesomeIcon icon="edit" className={iconClass} />
        ),
        [UpdateState.AwaitApproval]: (
            <FontAwesomeIcon icon="user-edit" className={iconClass} />
        ),
        [UpdateState.Scheduled]: (
            <FontAwesomeIcon icon={['far', 'calendar-check']} className={iconClass} />
        ),
        [UpdateState.Running]: (
            <FontAwesomeIcon icon="download" className={iconClass} />
        ),
        [UpdateState.Canceled]: (
            <FontAwesomeIcon icon="ban" className={iconClass} />
        ),
        [UpdateState.Error]: (
            <FontAwesomeIcon icon="exclamation-triangle" className={iconClass} />
        ),
        [UpdateState.Done]: (
            <FontAwesomeIcon icon="check" className={iconClass} />
        ),
    }

    return icons[state];
};